import { post } from '../utilities/http';
import EnvHelper from '../helpers/envHelper';

const envHelper = EnvHelper.getInstance();

export const openPosition = async (data) => {
  return post(`${envHelper.getApiUrl()}/v2/trade/open-position`, data);
};

export const closePositionApi = async (data) => {
  return post(`${envHelper.getApiUrl()}/v2/trade/close-position`, data);
};

export const deleteOrderApi = async (data) => {
  return post(`${envHelper.getApiUrl()}/v2/trade/delete-order`, data);
};

export const editPositionApi = async (data) => {
  return post(`${envHelper.getApiUrl()}/v2/trade/edit-position`, data);
};

export const editOrderApi = async (data) => {
  return post(`${envHelper.getApiUrl()}/v2/trade/edit-order`, data);
};
